import LeadConversationList from './LeadConversationList';

export default LeadConversationList;
